<template>
  <v-btn dark fab x-small color="blue darken-3" @click="exportDialog=true">
    <v-icon dark>mdi mdi-file-export</v-icon>
    <v-dialog persistent v-model="exportDialog" width="500" transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="blue darken-3">
          <v-toolbar-title>Export Options</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-2">
          <v-container grid-list-md>
            <v-layout wrap row>
              <!--                            <v-flex xs12>-->
              <!--                                <v-text-field label="Name of export" v-model="exportName" outlined-->
              <!--                                              type="text"></v-text-field>-->
              <!--                            </v-flex>-->
              <v-flex xs12>
                <v-radio-group v-model="exportType" :mandatory="true">
                  <v-radio
                      label="Export as PDF"
                      value="pdf"
                  ></v-radio>
                  <v-radio
                      label="Export as Excel"
                      value="excel"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
              <!--                            <v-flex xs12 class="py-0">-->
              <!--                                <v-checkbox v-model="exportRows" label="Export All" value="all"></v-checkbox>-->
              <!--                            </v-flex>-->
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="red lighten-1"
              :disabled="loading"
              class="white--text"
              @click="closeDialog "
          >Cancel
          </v-btn>
          <v-btn color="blue darken-3" :loading="loading" class="white--text" @click="exportExcel">Export
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-btn>

</template>

<script>
import Http from 'axios';
import {VERSIONED_API_URL} from "../config/config";

const EXPORT_URL = `${VERSIONED_API_URL}/summary-report`;

export default {
  name: 'ExportSummaryReportButton',
  props: {
    exportDate: {
      type: Object,
    },
    exportCountry: {
      type: [String, Array]
    },
    exportPurpose:{
      type:String
    },
    exportRoute: {
      type: [String, Array]
    },
    exportAgency:{
      type :[String,Array]
    },
    exportOffice:{
      type :[String,Array]
    },
    model: {
      type: String,
      required: true
    },
    passportType: {
      type: [Array]
    },
    office: {
      type: Number
    }
  },
  data() {
    return {
      exportDialog: false,
      loading: false,
      exportType: null
    };
  },
  methods: {
    closeDialog() {
      this.exportDialog = false;
    },
    exportExcel() {
      this.loading = true;
      let params = {};
      let url = EXPORT_URL + '/' + this.model + '/export';
      params.type = this.exportType;
      let date_range = this.exportDate;
      let country = this.exportCountry;
      if (date_range)
        params.date_range = date_range;
      if (country)
        params.country = country;
      if (this.passportType)
        params.passport_type = this.passportType;
      if (this.office)
        params.office_id = this.office;
      if (this.exportRoute)
        params.trekking_route = this.exportRoute;
      if (this.exportAgency)
        params.trekking_agency = this.exportAgency;
      if (this.exportOffice)
        params.office = this.exportOffice;
      if (this.exportPurpose)
        params.purpose = this.exportPurpose;
      Http.get(url, {
        params: params
      }).then((res) => {
        this.loading = false;
        this.closeDialog()
        window.open(res.data.link, "_blank");
        this.$store.commit('Notification/showSuccess', 'Data exported successfully')
      }).catch(error => {
        this.loading = false;
        this.$store.commit('Notification/showError', 'Something went wrong')
      })
    }
  }
}
</script>
